import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { isEmpty } from "../../../utils/Validation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetNewsletter } from "../../../utils/GetNewsletter";
import emojihand from "../../../assets/images/icon/hand👋.png";
import TagManager from "react-gtm-module";
import { apiService } from "../../../api/apiService";

const FromContact = ({ className = "" }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});

  const onChange = (e) => {
    let { name, value } = e.target;
    if (name === "phone") {
      if (!value || value.match(/^[0-9]+$/g)) {
        setForm({ ...form, [name]: value });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
    setErrors(validate(true, name, value));
  };

  const validate = (isOnchange = false, name, value) => {
    let error = { ...errors };

    if (isOnchange) {
      if (name === "name") error["name"] = isEmpty(value, "su Nombre");
      if (name === "email") error["email"] = isEmpty(value, "su Email");
      if (name === "phone") error["phone"] = isEmpty(value, "su Celular");
    } else if (!isOnchange) {
      let _form = { ...form };
      error["name"] = isEmpty(_form.name, "su Nombre");
      error["email"] = isEmpty(_form.email, "su Email");
      error["phone"] = isEmpty(_form.phone, "su Celular");
    }

    Object.keys(error).forEach((elem) => {
      if (error[elem] === "") delete error[elem];
    });

    return error;
  };
  const handleButtonClick = (category, action, label) => {
    TagManager.dataLayer({
      dataLayer: {
        event: category,
        category: category,
        action: action,
        label: label,
      },
    });
  };
  const onSubmit = () => {
    let _errors = validate();
    setErrors(validate());

    if (!Object.keys(_errors).length > 0) {
      handleButtonClick("Mensaje", "clic en boton", "Enviar");

      sendEmail();
    }
  };

  const sendEmail = async () => {
    let _form = { ...form };
    try {
      const response = await apiService().email.newsLetters(_form)
      const { Status } = response.data.Messages[0]
      if (Status === 'success') {
        toast.success("¡Muchas gracias!, nos pondremos en contacto contigo.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error)
      toast.error("Ups!, algo salío mal.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  return (
    <>
      <form onClick={handleSubmit}>
        <ToastContainer />
        <div className="row controls">
          <div className="col-12">
            <div className="input-group-meta form-group mb-25">
              {/* <label>Nombre</label> */}
              <input
                type="text"
                placeholder="Nombre"
                name="name"
                required
                value={form.name}
                onChange={(e) => onChange(e)}
                style={errors["name"] && { borderColor: "red" }}
              />
              <div className="help-block with-errors"></div>
            </div>
          </div>

          <div className="col-12">
            <div className="input-group-meta form-group mb-25">
              {/* <label>Correo</label> */}
              <input
                type="email"
                placeholder="Correo"
                name="email"
                required
                value={form.email}
                onChange={(e) => onChange(e)}
                style={errors["email"] && { borderColor: "red" }}
              />
              <div className="help-block with-errors"></div>
            </div>
          </div>

          <div className="col-12">
            <div className="input-group-meta form-group mb-25">
              {/* <label>Celular</label> */}
              <input
                type="text"
                placeholder="Celular"
                name="phone"
                required
                maxLength={9}
                value={form.phone}
                onChange={(e) => onChange(e)}
                style={errors["phone"] && { borderColor: "red" }}
              />
              <div className="help-block with-errors"></div>
            </div>
          </div>
          <div className="col-5">
            <button
              className={`ripple-btn w-100 ${className} border-0 rounded-3xl flex items-center justify-center gap-2`}
              onClick={() => {
                onSubmit();
              }}
            >
              <p className="m-0 p-0">Enviar</p>
              <LazyLoadImage src={emojihand} alt={"emojihand"} className="w-5 h-5" />
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default FromContact;
